import React from "react";
import curve from "../assets/icons/curvyline.svg";
import SEO from "./SEO";
import { blogData } from "./NewsEvents/blog-data";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const NewsEvent = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/news-event",
      title: "News and Events | SynergyCare Foundation",
    });
  });
	return (
		<div className='container mx-auto lg:pt-40 pt-24 pb-16'>
			<SEO
				title='News and Events | SynergyCare Foundation'
				description='Stay updated on the latest news and upcoming events from SynergyCare Foundation.'
				name='SynergyCare Foundation'
				type=''
			/>
			{/* Title and Description */}
			<div className='relative text-center'>
				<h1 className='lg:text-[64px] text-5xl lg:leading-[76px] leading-[60px] font-semibold text-[#11112D]'>
					News and Events
				</h1>

				<img src={curve} alt='Icon 1' className='absolute top-0 right-0' />
			</div>

			<p className='w-[90%] lg:w-[50%] md:w-[50%] text-center mt-14 text-lg mx-auto text-[#11112d] font-normal mb-8'>
				Stay updated on the latest news and upcoming events from SynergyCare
				Foundation.
			</p>

			<ul className='grid gap-4 lg:grid-cols-2 md:grid-cols-2 grid-cols-1'>
				{blogData.map((blog) => (
					<li key={blog.id} className='space-y-8 max-w-[560px] w-full'>
						<div
							className='min-h-[280px] max-w-[560px] w-full bg-no-repeat bg-cover bg-center relative'
							style={{ backgroundImage: `url(${blog.imageSrc})` }}>
							<div className='bg-white/20 backdrop-blur-lg text-gray-900 flex items-center justify-between p-6 mt-0 absolute bottom-0 w-full text-sm/5'>
								<div>
									<p>{blog.author}</p>
									<p>{blog.post_date}</p>
								</div>
								<ul>
									{blog.tag.map((data) => (
										<li>{data}</li>
									))}
								</ul>
							</div>
						</div>

						<div className=' space-y-2'>
							<p className='text-[14px] lg:text-[18px]'>{blog.title}</p>
							<p className='text-[14px] lg:text-[16px] text-[#667085]'>
								{blog.strong_point}
							</p>
							<Link
								to={`/news-event/${blog.id}`}
								className='text-[14px] lg:text-[16px] text-[#15A359] block w-fit'>
								Read post
							</Link>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default NewsEvent;
